import axios, { CancelToken, isCancel } from 'axios';

import { addInterceptors, apiRequestBase, getTctRequestConfig } from './logic';

const tctAxios = axios.create(getTctRequestConfig());
addInterceptors(tctAxios);

export const apiRequest = apiRequestBase(tctAxios, CancelToken, isCancel);
